import { DateTime } from 'luxon';
import { getPayPeriodRangeFromDate } from 'components/BKJDatePicker/src/BKJDatePicker.utils';
import { IPayPeriodConfig } from 'components/BKJDatePicker/src/BKJDatePicker.types';
import { ISO8601TupleType } from 'types/common.types';

export const isSinglePayPeriodRange = (
  range: ISO8601TupleType,
  config: IPayPeriodConfig,
): boolean => {
  const [periodStart, periodEnd] = getPayPeriodRangeFromDate(range[0], config);
  return (
    DateTime.fromISO(range[0]).hasSame(DateTime.fromISO(periodStart), 'day') &&
    DateTime.fromISO(range[1]).hasSame(DateTime.fromISO(periodEnd), 'day')
  );
};

export const isSameDayRange = (a: ISO8601TupleType, b: ISO8601TupleType): boolean =>
  DateTime.fromISO(a[0]).hasSame(DateTime.fromISO(b[0]), 'day') &&
  DateTime.fromISO(a[1]).hasSame(DateTime.fromISO(b[1]), 'day');
